import { Button, Card, Select, Space, Table } from "@arco-design/web-react";
import { Currency } from "@/components/Numeric";
import { VendorSelect } from "@/components/VendorSelect";
import { useCallback, useEffect, useState } from "react";
import { POAPI } from "@/apis/purchasing";
import { POInfo } from "./po-info";
import { POAdd } from "./po-add";
import { POEdit } from "./po-edit";
import { POStatusDef, POStatus } from "@/enums/purchasing";
import Reference from "@/components/Reference";
import { EnumLabel } from "@/components/Enum";
import { Link } from "react-router-dom";
import { IconPlus } from "@arco-design/web-react/icon";

export const PO = () => {
    const [vendorId, setVendorId] = useState(null);
    const [status, setStatus] = useState(-1);
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);

    const getPOs = useCallback(async () => {
        let statusList = [status];
        if (status === -1) {
            statusList = [POStatus.Created, POStatus.Issued, POStatus.Partial];
        } else if (status === 0) {
            statusList = undefined;
        }

        const values = await POAPI.query({ page, status: statusList, vendorId });
        setData(values.records);
        setTotal(values.total);

    }, [status, vendorId, page]);

    useEffect(() => {
        getPOs();
    }, [getPOs]);

    return (
        <Card title="Purchasing Orders" extra={
            <Space>
                <VendorSelect allowClear placeholder="Select vendor" onChange={(val) => {
                    setVendorId(val);
                }} style={{ width: 200 }} />
                <Select options={[
                    { label: "All", value: 0 },
                    { label: "Open", value: -1 },
                    ...Object.entries(POStatusDef).map(([, item]) => ({
                        value: item.value,
                        label: item.label
                    }))
                ]}
                    value={status}
                    placeholder="Status" style={{ width: 200 }}
                    onChange={(val) => {
                        setStatus(val);
                    }} />
                <Link to="/workspace/purchasing/po/add">
                    <Button type="primary" icon={<IconPlus />}>Create New PO</Button>
                </Link>
            </Space>
        }>
            <Table rowKey="id"
                columns={[
                    {
                        title: "PO#",
                        render: (col, record, index) =>
                            <Link to={"/workspace/purchasing/po/" + record.id}>{record.poNo}</Link>
                    },
                    { title: "Status", dataIndex: "status", render: (col, record) => <EnumLabel enumObj={POStatusDef} value={record.status} /> },
                    { title: "Vendor", dataIndex: "vendorName" },
                    { title: "Reference#", render: (col, record) => <Reference value={record.reference} /> },
                    { title: "PO Date", dataIndex: "poDate" },
                    { title: "Due Date", dataIndex: "dueDate" },
                    { title: "ETA", dataIndex: "eta" },
                    {
                        title: "Total Amount", dataIndex: "totalAmount",
                        render: (col, record) => <Currency value={record.totalAmount} />
                    },
                ]}
                pagination={{ total, current: page, pageSize: 20 }}
                data={data}
                onChange={(pagination) => setPage(pagination.current)}
            />

        </Card>
    );
}

PO.Info = POInfo;
PO.Add = POAdd;
PO.Edit = POEdit;
